/* unplugin-vue-components disabled */import { render } from "./TextAnalogyQuestionForm.vue?vue&type=template&id=d72cf566&scoped=true"
import script from "./TextAnalogyQuestionForm.vue?vue&type=script&lang=js"
export * from "./TextAnalogyQuestionForm.vue?vue&type=script&lang=js"

import "./TextAnalogyQuestionForm.vue?vue&type=style&index=0&id=d72cf566&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72cf566"]])

export default __exports__